import React from 'react';
import { Component } from "puzzle";
import { MULTI_CLAIM_TASK } from "./Types";

type PROPS = {
  responseData: MULTI_CLAIM_TASK[],
  claimSwitch: 'Claim' | 'Unclaim' //whether it is claim or unclaim action
}

class MultiClaimTasksWarning extends Component<PROPS, {}> {
  renderBody() {
    const { responseData } = this.props;
    return (
      <>
        <span className={"tp-warning-text  tp-text-semibold"}>{this.translate('header' + this.props.claimSwitch)}</span>
        <div className={'tp-warning-dialog-list'}>
          <ul>{responseData.map((task: MULTI_CLAIM_TASK, index: number) => {
            return <li key={index}>
              {this.translate('item', {
                id: task.submissionId,
                batchName: task.batchName,
                language: task.targetLanguageDisplayName,
                phaseName: task.phaseName
              })}
            </li>
          })}</ul>
        </div>
      </>
    );
  }
}

export default MultiClaimTasksWarning;
